import React from 'react';
import PropTypes from 'prop-types';
import './PageHeader.scss';

const PageHeader = (props) => {
  const { title } = props;

  return (
    <div className="page-header-wrapper">
      <h1>{title}</h1>
    </div>
  );
};

PageHeader.propTypes = {
  title: PropTypes.string
};

export default PageHeader;



/** WEBPACK FOOTER **
 ** ./src/components/PageHeader/PageHeader.js
 **/